/* import __COLOCATED_TEMPLATE__ from './error.hbs'; */
import Component from '@glimmer/component';
import bbFrontendGlyphIconToSvg from '@banking/ui/utils/bb-frontend-glyph-icon-to-svg';
export default class CreatePrintableCheckError extends Component {
  get icon() {
    return bbFrontendGlyphIconToSvg(this.args.unrecoverableError.icon);
  }
}